import { Box } from "@mui/material"
import { NormalText } from "../../shared/styles"
import { Button } from "../../shared/button/button"

export const AuthenticatorContainer = () => {
  const handleEnable2FA = () => {
    console.log("enable 2fa")
  }

  return (
    <Box display={"flex"} flexDirection={"column"} gap={"16px"}>
      <NormalText isBold color={"#0F110C"} size={16}>
        Double authentication
      </NormalText>
      <NormalText size={14}>
        Two-Factor Authentication is always enabled for your account. You will
        be required to enter a 6-digit code sent to your email each time you log
        in to the platform. This cannot be disabled or used for other actions at
        the moment.
      </NormalText>
      <Button
        label={"Enable"}
        onClick={handleEnable2FA}
        isDisabled={true}
        tooltipLabel={
          "It cannot be disabled or applied to other actions at this time."
        }
      />
    </Box>
  )
}
